import { createSlice } from '@reduxjs/toolkit';
import { getLegacyTiposCombustible } from '../legacy/thunk.js';

export const initialState = {
    legacyTiposCombustible: [],
    loading: false,
    error: {},
};

const legacyTiposCombustibleSlice = createSlice({
    name: 'legacyTiposCombustible',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyTiposCombustible.fulfilled, (state, action) => {
            state.legacyTiposCombustible = action.payload;
            state.loading = true;
        });
        builder.addCase(getLegacyTiposCombustible.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = true;
        });
        builder.addCase(getLegacyTiposCombustible.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
    }
});

export default legacyTiposCombustibleSlice.reducer;